<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">SECTION C: FEES AND CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE</p>
                    </div>
                    <div>
                        <p>The following fees and charges reflect the financial structure of the TEFL certificate program cohort.</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr></b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-html="menu.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-tefl-c"
                                        v-model="form.status"
                                        name="checkbox-tefl-c"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox>
                                    <p>
                                        I read and confirm that I understand the information in Section C.
                                    </p>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    props: {
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            form: {},
            data: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const info = this.studentInformation;
            this.data.push(
                {
                    key: 'Tuition Deposit',
                    value: `$${info?.tuition_deposit ? info.tuition_deposit : 'xxx'} – Non-Refundable (credited toward total tuition).`,
                },
                {
                    key: 'Total TEFL Course Tuition',
                    value: `$${info?.tuition_fee ? parseFloat(info.tuition_fee) : 'xxx'} (Flat rate course cost covers all 120 instructional hours, LMS digital teaching tool access, integrated career seminars and completion certificate).`,
                },
                {
                    key: 'Mandatory Program Fees',
                    value: 'Student Identification Card $22. (For in-person modality only)',
                },
                {
                    key: 'Other Fees May Apply',
                    value: 'Institutional documentation requests (For example, requests by students for official university documents (e.g., requests for transcripts, enrollment verifications and academic records) may require payment of the relevant fee(s). Information about the above-mentioned university fees and other fees can be found on Bay Atlantic University\'s website.)',
                },
            )
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
